import React, { createContext, useState } from 'react';

const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  const [contextData, setContextData] = useState({
    isOpen: false
  });

  return (
    <GlobalContext.Provider value={{ contextData, setContextData }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;